import { createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'

import reducer from './reducer'

// @ts-ignore
let store = createStore(reducer, composeWithDevTools())

export default store
